import { Nullable } from 'common-types';
import QuickFixStore from '../stores/quick-fix-store';
import { ViewFix } from '../types/quick-fix-types';

export const setIsLoadingCreatePR = (isLoading: boolean) => {
  QuickFixStore.isLoadingCreatePR = isLoading;
};

export const setIsLoadingDeletePR = (isLoading: boolean) => {
  QuickFixStore.isLoadingDeletePR = isLoading;
};

export const updatePRComment = (comment: string) => {
  QuickFixStore.prComment = comment;
};

export const clearPRComment = () => {
  QuickFixStore.prComment = '';
};

export const setFix = (fix: ViewFix) => {
  QuickFixStore.viewFileFixes = fix.viewFileFixes;
  QuickFixStore.prBody = fix.prBody;
  QuickFixStore.prTitle = fix.prTitle;
};

export const setLoadingFix = (value: boolean) => {
  QuickFixStore.isLoadingFileFixes = value;
};

export const setAutoFixId = (value: string) => {
  QuickFixStore.autoFixId = value;
};

export const clearStore = () => {
  QuickFixStore.prComment = '';
  QuickFixStore.autoFixId = '';
  QuickFixStore.isLoadingFileFixes = false;
  QuickFixStore.viewFileFixes = [];
  QuickFixStore.prBody = '';
  QuickFixStore.prTitle = '';
};

export const setLoadingError = (value: boolean) => {
  QuickFixStore.loadingError = value;
};

export const setError = (value: Nullable<string>) => {
  QuickFixStore.errorMessage = value;
};
